import { Component, Input } from '@angular/core';
import { Events, } from 'ionic-angular';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { StoreWrapProvider } from '../../providers/store-wrap/store-wrap';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service';
@Component({
  selector: 'private-share',
  templateUrl: 'private-share.html'
})
export class PrivateShareComponent {

  text: string;
  @Input() sharedData: any;
  @Input() params: any
  broadcastSubs: any;
  constructor(public communicationServ: CommunicationServiceProvider, public events: Events, public driveService: DriveServiceProvider, public storeWrap: StoreWrapProvider, public configApiService: ConfigApiServiceProvider) {
    this.events.subscribe('showComponentHolder', (flag) => {
      if (!flag) {
        let index = this.driveService.objRootFolder.folders.findIndex(element => element.name == 'FileShared');

        if (index != -1) {
          this.driveService.objCurrentFolder = this.driveService.objRootFolder['folders'][index];
        }
      }
    });

    //  this.events.subscribe('clickedMenuId',(sideMenuid)=>{

    //     if(this.driveService.objCurrentParentFolder.template.length>1){
    //       for(var idx =0;idx<this.driveService.objCurrentParentFolder.template.length;idx++){
    //        delete this.storeWrap.storeTemplates[this.driveService.objCurrentParentFolder.template[idx].id].fieldProperties;
    //       }
    //     }else{
    //         delete this.storeWrap.storeTemplates[this.driveService.objCurrentParentFolder.template[0].id].fieldProperties;
    //     }
    //     this.events.unsubscribe('clickedMenuId');

    //  })

    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "sidePanel") {
          if (data.event === 'clickedMenuId') {
            if (this.driveService.objCurrentParentFolder.template.length > 1) {
              for (var idx = 0; idx < this.driveService.objCurrentParentFolder.template.length; idx++) {
                delete this.storeWrap.storeTemplates[this.driveService.objCurrentParentFolder.template[idx].id].fieldProperties;
              }
            } else {
              delete this.storeWrap.storeTemplates[this.driveService.objCurrentParentFolder.template[0].id].fieldProperties;
            }
          }
        }
      });

  }

  ngAfterViewInit() {
    if (!this.sharedData) {
      this.sharedData = this.params;
      this.sharedData['sharedInfo'] = eval('(' + this.sharedData.Sharedinfo + ')');
    }
    this.driveService.objCurrentFolder = this.sharedData['sharedInfo']['sharedFolder'];
    let objEnableTrack: any = '';
    objEnableTrack = this.driveService.objCurrentFolder['objEnableTrack'];
    if (objEnableTrack) {
      objEnableTrack = JSON.parse(objEnableTrack);

      let tracker_Id = objEnableTrack['tracker_Id'];
      let trackerIndex: any = this.driveService.objCurrentFolder.template.findIndex(element => element.id == tracker_Id);
      if (trackerIndex != -1) {
        this.driveService.objCurrentFolder.template.splice(trackerIndex, 1);
      }
    }
    let arrTemplateProps = [];
    if (this.sharedData['sharedInfo']['sharedFolder']["template"].length > 1) { // changing the validation to 1 from >1
      for (let idx = 0; idx < this.sharedData['sharedInfo']['sharedFolder']["template"].length; idx++) {

        if (this.storeWrap.storeTemplates[this.sharedData['sharedInfo']['sharedFolder']["template"][idx].id]) {
          arrTemplateProps.push(this.storeWrap.storeTemplates[this.sharedData['sharedInfo']['sharedFolder']["template"][idx].id]);
          if (arrTemplateProps.length == this.sharedData['sharedInfo']['sharedFolder']["template"].length) {
            this.driveService.objCurrentParentFolder = this.sharedData['sharedInfo']['sharedFolder'];
            this.driveService.broadcastInfo({ src: 'compLoad', event: 'triggerComponentLoad', status: 'editdata', item: arrTemplateProps, param: this.sharedData.sharedInfo.rowData[0] });
          }
        } else {
          let _template = Object.assign({}, this.configApiService.driveApi.pullFolderTemplate.params, this.sharedData['sharedInfo'].pullFolderTemplate, { "ScreenName": this.sharedData['sharedInfo'].sharedFolder.template[idx].id });
          this.configApiService.pullRequest(_template, (temp) => {

            this.storeWrap.storeTemplates[eval('(' + temp[0].PluginData + ')')['id']] = eval('(' + temp[0].PluginData + ')');
            arrTemplateProps.push(this.storeWrap.storeTemplates[this.sharedData['sharedInfo']['sharedFolder']["template"][idx]['id']]);
            if (arrTemplateProps.length == this.sharedData['sharedInfo']['sharedFolder']["template"].length) {
              this.driveService.objCurrentParentFolder = this.sharedData['sharedInfo']['sharedFolder'];
              this.driveService.broadcastInfo({ src: 'compLoad', event: 'triggerComponentLoad', status: 'editdata', item: arrTemplateProps, param: this.sharedData.sharedInfo.rowData[0] });
            }
          });
        }
      }

    } else {
      if (!this.storeWrap.storeTemplates[this.sharedData['sharedInfo']['sharedFolder']["template"][0]['id']]) {
        let _template = Object.assign({}, this.configApiService.driveApi.pullFolderTemplate.params, this.sharedData['sharedInfo'].pullFolderTemplate, { "ScreenName": this.sharedData['sharedInfo'].sharedFolder.template[0].id });
        this.configApiService.pullRequest(_template, (temp) => {

          this.storeWrap.storeTemplates[eval('(' + temp[0].PluginData + ')')['id']] = eval('(' + temp[0].PluginData + ')');
          if (this.storeWrap.storeTemplates[this.sharedData['sharedInfo']['sharedFolder']["template"][0]['id']]['componentName'] == 'FormGridComponent') {
            this.storeWrap.storeTemplates[this.sharedData['sharedInfo']['sharedFolder']["template"][0]['id']]['componentName'] = "FORM";
          }
          arrTemplateProps.push(this.storeWrap.storeTemplates[this.sharedData['sharedInfo']['sharedFolder']["template"][0]['id']]);
          this.driveService.objCurrentParentFolder = this.sharedData['sharedInfo']['sharedFolder'];
          this.driveService.broadcastInfo({ src: 'compLoad', event: 'triggerComponentLoad', status: 'editdata', item: arrTemplateProps, param: this.sharedData.sharedInfo.rowData[0] });
        })
      } else {
        if (this.storeWrap.storeTemplates[this.sharedData['sharedInfo']['sharedFolder']["template"][0]['id']]['componentName'] == 'FormGridComponent') {
          this.storeWrap.storeTemplates[this.sharedData['sharedInfo']['sharedFolder']["template"][0]['id']]['componentName'] = "FORM";
        }
        arrTemplateProps.push(this.storeWrap.storeTemplates[this.sharedData['sharedInfo']['sharedFolder']["template"][0]['id']]);
        this.driveService.objCurrentParentFolder = this.sharedData['sharedInfo']['sharedFolder'];
        this.driveService.broadcastInfo({ src: 'compLoad', event: 'triggerComponentLoad', status: 'editdata', item: arrTemplateProps, param: this.sharedData.sharedInfo.rowData[0] });
      }
    }

  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/components/private-share/private-share.ts